
export default {
  name: "Tag",
  scrollToTop: true,
  async asyncData({ $content, params, error }) {
    const name = params.tag || "index";

    const articles = await $content(`articles`)
      .where({ tags: { $contains: params.tag } })
      .sortBy("date", "desc")
      .fetch()
      .catch(() => {
        error({ statusCode: 404, message: "no articles with this tag" });
      });

    return {
      name,
      articles,
    };
  },
  data() {
    return {
      dateOptions: {
        year: "numeric",
        month: "long",
        day: "numeric",
      },
    };
  },
  head() {
    return {
      title: `#${this.name}`,
      titleTemplate: "%s | INDOMASCOT",
    };
  },
};
